import React from 'react';
import { Link, useParams, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { isAxiosError } from 'axios';
import { useMunicipalityId } from '../../hooks/useCouncilPath';
import { buildCouncilPath } from '../../utils/councilParams';
import './NotFound.css';

type Props = {
    customError?: number;
};

function NotFound({ customError }: Props) {
    const { bodyType, zastupitelstvoId } = useParams();
    const municipalitaId = useMunicipalityId();
    const to =
        bodyType !== undefined && zastupitelstvoId !== undefined
            ? buildCouncilPath(municipalitaId, bodyType, zastupitelstvoId)
            : '/';

    const { t } = useTranslation();
    const error = useRouteError();

    let msg = ' ';
    let state: number | undefined;

    if (isRouteErrorResponse(error)) {
        // React Router Error
        if (error.status === 400) {
            state = 400;
            msg = 'Požadavek nemůže být vyřízen.';
        }

        if (error.status === 401) {
            state = 401;
            msg = 'Neautorizovaný přístup.';
        }

        if (error.status === 404) {
            state = 404;
            msg = t('NotFound.pageNotFound');
        }

        if (error.status === 500) {
            state = 500;
            msg = 'Při zpracování požadavku došlo ke blíže nespecifikované chybě.';
        }

        if (error.status === 503) {
            state = 503;
            msg = 'Služba momentálně není k dispozici.';
        }
    } else if (isAxiosError(error)) {
        // Axios Error
        if (error.code === 'ERR_NETWORK') {
            state = 500;
            msg = 'Při zpracování požadavku došlo ke blíže nespecifikované chybě.';
        }
        if (error.code === 'ERR_BAD_REQUEST' || error.code === 'ERR_BAD_RESPONSE' || error.code === 'ERR_UNPROCESSABLE_ENTITY') {
            state = 404;
            msg = t('NotFound.pageNotFound');
        }
    } else if (customError) {
        if (customError === 404) {
            state = 404;
            msg = t('NotFound.pageNotFound');
        }
    }

    return (
        <>
            <div className='not-found'>
                <span className='content'>
                    <i className='pi bi-emoji-frown icon'></i>
                    {/*title*/}
                    <span className='title'>{state}</span>
                    <div className='text'>
                        {msg}

                        {state === 404 && (
                            <>
                            <br />
                            <Trans
                                i18nKey='NotFound.youCanReturnToHomepage'
                                components={[<Link className='link' to={to} />]}
                            />
                            </>
                        )}
                    </div>
                </span>
            </div>
        </>
    );
}

export default NotFound;
